import styled from 'styled-components';

export const ActionButton = styled.div`
  background: #225a91;
  border: 1px solid #225a91;
  cursor: pointer;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 11px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  position: relative;
`;
